import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";

import { SuggestedActions } from "./SuggestedActions";

import { GOAL_COACH_START_QUERY } from "../constants";

type GoalCoachSuggestedActionsProps = {
	onSelect: (query: string) => void;
};

export const GoalCoachSuggestedActions: React.FC<GoalCoachSuggestedActionsProps> = ({ onSelect }) => {
	return (
		<SuggestedActions
			size="large"
			actions={[
				{
					label: "Suggest improvements for my goal",
					icon: faSparkles,
					onClick: () => onSelect(GOAL_COACH_START_QUERY),
				},
			]}
		/>
	);
};
